export const moduleSlug = "USERS";

export default { moduleSlug };